module.exports = __webpack_public_path__ + "static/media/image-default.2d72c7e4.png";